var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalAlt2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#isbiygdhaa)",
    fill: "#697482"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.458 3H3.542A3.546 3.546 0 0 0 0 6.542h17A3.546 3.546 0 0 0 13.458 3zM0 12.207a3.546 3.546 0 0 0 3.542 3.542h9.917A3.546 3.546 0 0 0 17 12.207v-4.25H0v4.25zm4.958-.355a1.063 1.063 0 1 1-2.126 0 1.063 1.063 0 0 1 2.126 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "isbiygdhaa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 3)",
    d: "M0 0h17v12.75H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalAlt2);
export default __webpack_public_path__ + "static/media/signal-alt-2.d619ab22d392d2cbd726a2416ef8c401.svg";
export { ForwardRef as ReactComponent };